$(function() {
    $('.fancy, [data-fancybox]').fancybox({
        closeClickOutside: true,
        touch: true,
        loop: true,
        gutter: 30,
    });
});
